// extracted by mini-css-extract-plugin
export var printerCard = "_bm-1";
export var printerCardConfigured = "_bm-2";
export var printerCardError = "_bm-3";
export var printerCardsContainer = "_bm-0";
export var printerIcon = "_bm-8";
export var printerIconConfigured = "_bm-5";
export var printerIconContainer = "_bm-4";
export var printerIconError = "_bm-6";
export var printerIconUnconfigured = "_bm-7";
export var workstationsTableCard = "_bm-9";